import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  API_ENDPOINT,
  primaryPaletteColor,
} from '../configurations/global.config';
import { AuthContext } from './user-context/user-context';
import axios from 'axios';
import { OrganisationSettings } from '../interfaces/delivery-company/orders';
import { useSnackBar } from './snackbar';

type Props = {
  children?: ReactNode;
};

type IOrgSettingsContextProps = {
  settings: OrganisationSettings;
  setSettings: (o: OrganisationSettings) => void;
  color: string,
  setColor: (c: string) => void
};

const initialValue: IOrgSettingsContextProps = {
  settings: {
    notification_templates: [],
    custom_primary_color: primaryPaletteColor,
    branding_message: "",
    navbar_logo: null,
    brand: '',
    default_driver_commission_settlement_mode: 'NET',
    critical_order_surcharge_factor: null
  },
  color: primaryPaletteColor,
  setSettings: () => {
    /* to be implemented */
  },
  setColor: () => {
    /* to be implemented */
  },
};

const OrgSettingsContext = createContext<IOrgSettingsContextProps>(initialValue);

const OrgSettingsProvider = ({ children }: Props) => {
  const { user, config } = useContext(AuthContext);
  const {showMessage} = useSnackBar()

  const [settings, setSettings] = useState<OrganisationSettings>(() => {
    // Initialize user state with the data from localStorage (if available)
    const storedSettings = localStorage.getItem('pt-org-settings');
    console.log("stored settings = " , JSON.parse(storedSettings!))
    const result =  storedSettings ? JSON.parse(storedSettings)  ?? initialValue.settings : initialValue.settings
    console.log(result)
    return result
  });

  const setColor = (c: string) => setSettings({...settings, custom_primary_color: c})

  useEffect(()=>{
    try {
      localStorage.setItem('pt-org-settings', JSON.stringify(settings));
    } catch {
      console.log("failed to save org settings to cache")
    }
  }, [settings])

  useEffect(() => {
    const getAndSetColor = async () => {
      if (user === null) return; // Make sure user is authenticated

      try {
        const response = await axios.get<OrganisationSettings>(
          `${API_ENDPOINT}/api/v1/settings`,
          config
        );

        console.log('Fetching = ', response.data);

        setSettings(response.data); // Update color state
        console.log(JSON.stringify(response.data))
        
        // Persist the color in localStorage
        localStorage.setItem('pt-org-settings', JSON.stringify(response.data));
      } catch (e) {
        console.error('Failed to fetch org settings:', e);
        showMessage("Failed to update settings. Refresh page.", 'error')
      }
    };

    // Fetch and set color if user exists
    getAndSetColor();

    // Refetch the color every 24 hours (8,64e+7 ms)
    const intervalId = setInterval(getAndSetColor, 864e7);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [user]); // Add `user` as a dependency to refetch when user changes

  return (
    <OrgSettingsContext.Provider value={{ settings,  setSettings, color: settings.custom_primary_color ?? primaryPaletteColor, setColor }}>
      {children}
    </OrgSettingsContext.Provider>
  );
};

export { OrgSettingsContext, OrgSettingsProvider };
